import React, { useState, useRef, useEffect } from "react";
import { InputMask } from 'primereact/inputmask';
import "../LoginSignup/LoginSignup.css";

function InputMSX(props) {
    const [maskVal, setmaskVal] = useState("");

    const convertString = (input) => {
        // Remove underscores and leading zeros
        const cleanedInput = input.replace(/_/g, '').replace(/^0+/, '');

        // Calculate the number of zeros to add
        const zerosToAdd = Math.max(8 - cleanedInput.length, 0);

        // Create the final output by adding zeros and the cleaned input
        const output = '0'.repeat(zerosToAdd) + cleanedInput;

        return output;
    }
    return (
        <div>
            <InputMask

                className="input-textbox"
                value={props.value}
                onChange={(event) => {
                    setmaskVal(event.target.value);
                   // console.log("maskval :", maskVal);
                }}
                onBlur={(event) => {
                    let r = maskVal;
                    //console.log("maskval blur :", r);
                    let converted = convertString(r);
                   /// console.log("converted :", converted);
                    let zerosCount = r.length - converted.length;
                   // console.log("zerosCount :", zerosCount);
                    let zeros = "";
                    for (let i = 0; i < zerosCount; i++) {
                        zeros += "0";
                    }
                   // console.log("zeros :", zeros);

                    let splitted = converted.split("D");
                   // console.log("splitted :", splitted);
                    let newSplit = splitted[0] + "D" + zeros + splitted[1];
                    if (newSplit === "00000000Dundefined") {
                        newSplit = ""
                    }
                    //console.log("newsplit :", newSplit);

                    props.onChange(newSplit);
                }}
                mask={props.mask}
                placeholder={props.placeholder}
                onComplete={(event) => {
                    let r = maskVal;
                   // console.log("maskval blur :", r);
                    let converted = convertString(r);
                   // console.log("converted :", converted);
                    let zerosCount = r.length - converted.length;
                   // console.log("zerosCount :", zerosCount);
                    let zeros = "";
                    for (let i = 0; i < zerosCount; i++) {
                        zeros += "0";
                    }
                    //console.log("zeros :", zeros);

                    let splitted = converted.split("D");
                    //console.log("splitted :", splitted);
                    let newSplit = splitted[0] + "D" + zeros + splitted[1];
                    if (newSplit === "00000000Dundefined") {
                        newSplit = ""
                    }
                    console.log("newsplit :", newSplit);

                    props.onChange(newSplit);
                }}
            />
        </div>
    );

}

export default InputMSX;